import React, { createContext, useState } from "react";

const initialState = { template: undefined };

export const SettingsContext = createContext(null);

const useSettings = () => {
    const [settings, setSettings] = useState(initialState);

    const setTemplate = (template) => setSettings((prevState) => ({ ...prevState, template }));

    return { settings, setTemplate };
};

const SettingsProvider = ({ children }) => {
    const setttings = useSettings();
    return (
        <SettingsContext.Provider value={setttings}>
            {children}
        </SettingsContext.Provider>
    );
};

export default SettingsProvider;
